import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

/**
 * Aviso informativo dentro de una pantalla (no es un botón ni se puede pulsar).
 * Estilos globales en scss/dhn/_notice-banner.scss.
 *
 * <NoticeBanner tone="warning" icon="fa-clock-o">Las auditorías se envían de madrugada.</NoticeBanner>
 */
export default function NoticeBanner({ children, className, icon, tone }) {
  return (
    <div
      role="note"
      className={classnames("dhn-notice-banner", `dhn-notice-banner--${tone}`, className)}
    >
      <span className="dhn-notice-banner__icon">
        <i className={classnames("fa", icon)} aria-hidden="true"></i>
      </span>
      <div className="dhn-notice-banner__text">{children}</div>
    </div>
  );
}

NoticeBanner.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  icon: PropTypes.string,
  tone: PropTypes.oneOf(["info", "warning", "danger"]),
};

NoticeBanner.defaultProps = {
  icon: "fa-info-circle",
  tone: "info",
};
